import image1 from "../../Assets/ourwork/image1.png";
import image2 from "../../Assets/ourwork/image2.png";
import image3 from "../../Assets/ourwork/image3.png";
import image4 from "../../Assets/ourwork/image4.png";
import image5 from "../../Assets/ourwork/image5.png";
import image6 from "../../Assets/ourwork/image6.png";

export const ourwork = [
  {
    id: 1,
    image: image1,
    title: "10 crore ke ghr hey ",
  },
  {
    id: 2,
    image: image2,
    title: "7 crore ke ghr hey ",
  },
  {
    id: 3,
    image: image3,
    title: "6 crore ke ghr hey ",
  },
  {
    id: 4,
    image: image4,
    title: "9 crore ke ghr hey ",
  },
  {
    id: 5,
    image: image5,
    title: "5 crore ke ghr hey ",
  },
  {
    id: 6,
    image: image6,
    title: "4 crore ke ghr hey ",
  },
];
